import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
/**
 * BaseSettingHandler
 */
abstract class BaseSettingHandler {
  inputName: string;
  setting: FormControlSetting;

  abstract read(options: any): any;
  abstract write(
    value: any,
    options: any,
  ): {
    refreshType: string; // "css" | "all"
    style?: string; // exist when refreshType = "css"
  };

  /**
   * setSetting
   * @param setting setting
   */
  setSetting(setting: FormControlSetting) {
    this.setting = setting;
  }
}

export const hello = 'hello';

export default BaseSettingHandler;

export type SettingHandlerClass = new (...args: any[]) => BaseSettingHandler;
/**
 * SettingHandlerController
 */
export class SettingHandlerManager {
  static handlerClasses: Record<string, SettingHandlerClass>;
  static handlerInstances: Record<string, BaseSettingHandler>;

  /**
   * register Handler Class
   * @param settingType settingType
   * @param handlerClass handlerClass
   */
  static registerHandlerClass(handlerClasses: Record<string, SettingHandlerClass>) {
    this.handlerClasses = handlerClasses;
    this.handlerInstances = {};
  }

  /**
   * get singleton of setting handler
   */
  static getSingleton(setting: FormControlSetting): BaseSettingHandler | undefined {
    let instance: BaseSettingHandler | undefined;
    /**
     * if exited
     */
    if (this.handlerInstances[setting.type]) {
      instance = this.handlerInstances[setting.type];
    } else if (this.handlerClasses[setting.type]) {
      const Class = this.handlerClasses[setting.type];
      instance = new Class();
      this.handlerInstances[setting.type] = instance;
    }

    if (instance) {
      instance.setSetting(setting);
    }

    return instance;
  }
}
